<template>
  <div id="NewProvider">
    <BannerRow >
      <div class="col-12 col-md-7 d-flex flex-column justify-content-center pt-3 pb-3">
        <div class="w-lg-75 ml-0 ml-md-5 pr-0">
          <h2 class="mb-lg-4 mb-1 primary-heading text-black font-weight-bold">
            <span class="d-block join">{{$t('providers.join')}}</span>
            <span class="join-title">{{$t('providers.title1')}}</span>
          </h2>
          <div class="mb-lg-2 mb-1 desc">
            {{$t('providers.des1')}}
          </div>
          <div>
            <span class="d-block download-app-title">{{$t('providers.download-app-title')}}</span>
            <div id="download-app" class="download-app">
              <a ref="google-play" class="google-play mr-2 mr-sm-3" href="https://play.google.com/store/apps/details?id=vn.oddjob.provider">
                <img class="pb-2" src="../assets/google-play.svg" alt="google play" />
              </a>
              <a class="app-store" href="https://apps.apple.com/vn/app/oddjob-vn-service-provider/id1520359766">
                <img class="pb-2" src="../assets/app-store.svg" alt="app store" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 d-none d-md-block banner-image"></div>
    </BannerRow>
    <WhiteRow>
      <div class="mt-5 ml-0 ml-md-5 mb-5">
          <h2 class='text-primary-heading text-black font-weight-bold'><p v-html="$t('providers.v-title2')"></p></h2>
        <div class="row mt-5">
          <div class="col-12 col-lg-6">
              <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.step1')}}</h4>
              <div>
                  <p v-html="$t('providers.des_step1')"></p>
              </div>
          </div>
        </div>


        <div class="row mt-2">
          <div class="col-12 col-lg-6">
            <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                    <select ref="phoneRegion" v-model="user.phoneRegion" class="form-control form-padding-common w-25 mr-3" label="Dial code" >
                      <option v-for="phoneRegion in phoneRegions"
                              :key="phoneRegion"
                              :value="phoneRegion"
                              >
                              {{phoneRegion}}
                      </option>
                    </select>
                    <div class="w-75 position-relative">  
                       <input  type="text" :disabled="disabledPhoneNumber" :data-vv-name="$t('providers.fields.phone_number')" v-validate="{ required: true, numeric: true, min:9 }" :ref="$t('providers.fields.phone_number')" maxlength="10" :name="$t('providers.fields.phone_number')" v-model="user.phone"  class="form-control phoneNumber w-100"  v-bind:placeholder="$t('providers.placeholder_enter_phone')">
                       <i @click="removePhoneNumber()"  v-if="user.verified" class="fa fa-times remove-phone-number position-absolute"></i>
                    </div>
                    <div v-if="user.verified" data-toggle="tooltip" title="Delete" class="verified pl-2">
                      <i class="fa fa-check"></i>
                    </div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                    <span class="w-25 mr-3"></span>
                    <span v-if="errors.has($t('providers.fields.phone_number'))" class="w-75 ml-2 text-danger error">{{ errors.first($t('providers.fields.phone_number')) }}</span>
                    <span v-if="user.error"  class="w-75 ml-2 text-danger error">{{user.error}}</span>
                </div>
            </div>
          </div>
          <div class="w-100"></div>
          <div class="col-12 col-lg-6">
              <div class="d-flex justify-content-between ">
                    <span class="w-25 mr-3">
                    </span>
                    <div class="w-75 d-flex align-items-center">
                        <button v-if="displayGetACode" :disabled="isPhoneNumber"  class="btn btn-primary text-white mr-3" @click="sendCode()" :class="{ setWidth: true }" type="button" size="mini">{{$t('providers.get_code')}}</button>
                        <span class="loading" v-if="user.loading"></span>
                        <span v-if="isShowCountDown" class="text-danger countdown">{{countDown}}s</span>
                    </div>
              </div>
              <div class="mt-3">
                  <!-- <div class="d-flex justify-content-between">
                        <span class="w-25 mr-3">
                        </span>
                        <div ref="recaptchaWrapperRef" class="w-75">
                            <div id="recaptcha-container" class="invisible"></div>
                        </div>
                  </div> -->
                  <div v-if="isShowInterfaceVerifyCode" class="d-flex show-interface-verify-code justify-content-between mt-2">
                      <div class="box-verify-code d-flex justify-content-between">
                          <input v-model="code" ref="code" maxlength="10" name="code" type="text" class="form-control code"  placeholder="Code">
                          <button :disabled="!code" class="btn btn-primary text-white ml-2 btn-confirm" @click="createUserOnFireBase(code)" :class="{ setWidth: true }" type="button" size="mini">{{$t('providers.verify')}}</button>
                      </div>
                  </div>
              </div>
          </div>
        </div>




        <div class="row no-gutters mt-5">
          <div class="col-12 col-lg-6">
              <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.step2')}}</h4>
              <div>
                <p v-html="$t('providers.des_step2')"></p>
              </div>
          </div>
        </div>




        <div class="row mt-5">
          <div class="col-12 col-lg-6">
              <div class="btn-group w-100 cursor-pointer" @click="changeProviderType('company')">
                  <button type="button"  :class="{ activeType: provider.type ==='company'}" class="provider-type btn border-setp-two-left text-white p-3 w-30 ">
                    <i class="fas fa-check text-gray"></i>
                  </button>
                  <div class="border-setp-two-right w-70">
                    <div class="d-flex flex-column align-items-center justify-items-center p-3">
                      <img class="rounded image-type" src="../assets/company.svg" />
                      <div class="text-black font-weight-bold">{{$t('providers.company')}}</div>
                    </div>
                  </div>
              </div>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">
             <div class="btn-group w-100 cursor-pointer" @click="changeProviderType('individual')">
                  <button type="button"  :class="{ activeType: provider.type ==='individual'}" class="provider-type border-setp-two-left btn text-white p-3 w-30">
                    <i class="fas fa-check text-gray"></i>
                  </button>
                  <div class="border-setp-two-right w-70">
                    <div class="d-flex flex-column align-items-center justify-items-center p-3">
                      <img class="rounded image-type"  src="../assets/individual.svg" />
                      <div class="text-black font-weight-bold">{{$t('providers.individual')}}</div>
                    </div>
                  </div>
              </div>
          </div>
        </div>

        <div v-if="provider.type === 'company'">

          <div class="row no-gutters mt-5">
            <div class="col-12 col-lg-6">
                <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.cop.step3')}}</h4>
                <div>
                  <p v-html="$t('providers.cop.des_step3')"></p>
                </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 col-lg-6">

                <div class="form-group">
                  <label class="tilte-input" for="businessCode">{{$t('providers.cop.business_code')}}</label>
                  <input :ref="$t('providers.fields.cop.business_code')" :data-vv-name="$t('providers.fields.cop.business_code')" maxlength="15" key="business-code"  v-validate="{required: true, numeric: true, min: 2, max: 15 }" :name="$t('providers.fields.cop.business_code')" v-model="provider.businessCode" type="text" class="form-control" id="businessCode" v-bind:placeholder="$t('providers.cop.placeholder_business_code')">
                  <span v-if="errors.has($t('providers.fields.cop.business_code'))" class="text-danger error">{{ errors.first($t('providers.fields.cop.business_code')) }}</span>
                </div>

                <div class="form-group">
                  <label class="tilte-input" for="name">{{$t('providers.cop.company_name')}}</label>
                  <input :ref="$t('providers.fields.cop.company_name_in_vietnamese')" :data-vv-name="$t('providers.fields.cop.company_name_in_vietnamese')" key="company-name-in-vietnamese" v-validate="'required'" v-model="provider.localName" :name="$t('providers.fields.cop.company_name_in_vietnamese')" type="text" class="form-control" id="localName"  v-bind:placeholder="$t('providers.cop.placeholder_company_name')">
                  <span v-if="errors.has($t('providers.fields.cop.company_name_in_vietnamese'))" class="text-danger error">{{errors.first($t('providers.fields.cop.company_name_in_vietnamese'))}}</span>
                </div>

                <div class="form-group">
                  <label class="tilte-input" for="abbreviatedName">{{$t('providers.cop.abbreviated_name')}}</label>
                  <input :ref="$t('providers.fields.cop.abbreviated_name')" :data-vv-name="$t('providers.fields.cop.abbreviated_name')" key="abbreviated-name" v-validate="'required'" :name="$t('providers.fields.cop.abbreviated_name')" v-model="provider.shortName"  type="text" class="form-control" id="abbreviatedName"  v-bind:placeholder="$t('providers.cop.placeholder_abbreviated_name')">
                  <span v-if="errors.has($t('providers.fields.cop.abbreviated_name'))" class="text-danger error">{{errors.first($t('providers.fields.cop.abbreviated_name'))}}</span>
               </div>

                <div class="form-group">
                  <label class="tilte-input" for="phoneNumber">{{$t('providers.cop.tel_number')}}</label>
                  <div class="d-flex justify-content-between">
                      <select v-model="provider.phoneRegionNumber" class="form-control form-padding-common w-25 mr-3">
                        <option v-for="phoneRegion in phoneRegions"
                                :key="phoneRegion"
                                :value="phoneRegion"
                                >
                              {{phoneRegion}}
                        </option>

                      </select>
                    <!-- Code validate -->
                    <!-- <input :ref="$t('providers.fields.cop.tel_number')" :data-vv-name="$t('providers.fields.cop.tel_number')" key="tel-number" v-model="provider.phones" v-validate="{required: true, numeric: true, min: 9}" maxlength="10" :name="$t('providers.fields.cop.tel_number')" type="text"  class="form-control w-75" v-bind:placeholder="$t('providers.cop.placeholder_tel_number')"> -->
                    <!-- No validate -->
                    <input :ref="$t('providers.fields.cop.tel_number')" :data-vv-name="$t('providers.fields.cop.tel_number')" key="tel-number" v-model="provider.phone" v-validate="{ numeric: true, min: 9}" maxlength="10" :name="$t('providers.fields.cop.tel_number')" type="text"  class="form-control w-75" v-bind:placeholder="$t('providers.cop.placeholder_tel_number')">
                  </div>
                  <div class="d-flex justify-content-between">
                      <div class="w-25"></div>
                      <div class="w-75">
                        <span v-if="errors.has($t('providers.fields.cop.tel_number'))" class="text-danger error ml-3">{{errors.first($t('providers.fields.cop.tel_number'))}}</span>
                      </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="tilte-input" for="fax">Fax</label>
                  <div class="d-flex justify-content-between">
                      <select v-model="provider.phoneRegionFax"  class="form-control form-padding-common w-25 mr-3">
                        <option v-for="phoneRegion in phoneRegions"
                                :key="phoneRegion"
                                :value="phoneRegion">
                              {{phoneRegion}}

                        </option>
                      </select>
                    <input ref="fax" data-vv-name="fax" v-model="provider.fax" v-validate="{numeric: true, min: 9}" name="fax" type="text" maxlength="10" class="form-control w-75" v-bind:placeholder="$t('providers.cop.placeholder_fax_number')">
                  </div>
                  <div class="d-flex justify-content-between">
                      <div class="w-25"></div>
                      <div class="w-75">
                        <span v-if="errors.has('fax')" class="text-danger error ml-3">{{errors.first('fax')}}</span>
                      </div>
                  </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                 <div class="form-group">
                    <SelectDate :id="$t('providers.fields.cop.the_first_registration_date')" :reset="resetDateTime" key="the-first-registration-date" v-validate="{required: true}" v-bind:title="$t('providers.cop.registration_date')" :name="$t('providers.fields.cop.the_first_registration_date')" v-model="provider.registrationDate"></SelectDate>
                    <span v-if="errors.has($t('providers.fields.cop.the_first_registration_date'))" class="text-danger error">{{errors.first($t('providers.fields.cop.the_first_registration_date'))}}</span>
                 </div>

                <div class="form-group">
                  <label class="tilte-input" for="nameForeign">{{$t('providers.cop.company_name_foreign')}}</label>
                  <!-- Code validate -->
                  <!-- <input :ref="$t('providers.fields.cop.company_name_in_foreign_language')" :data-vv-name="$t('providers.fields.cop.company_name_in_foreign_language')" key="company-name-in-foreign-language" v-validate="'required'" v-model="provider.globalName" :name="$t('providers.fields.cop.company_name_in_foreign_language')" type="text" class="form-control" id="globalName"  v-bind:placeholder="$t('providers.cop.placeholder_company_name_foreign')">
                  <span v-if="errors.has($t('providers.fields.cop.company_name_in_foreign_language'))" class="text-danger error">{{errors.first($t('providers.fields.cop.company_name_in_foreign_language'))}}</span> -->
                  <!-- No validate -->
                  <input :data-vv-name="$t('providers.fields.cop.company_name_in_foreign_language')" key="company-name-in-foreign-language"  v-model="provider.globalName" :name="$t('providers.fields.cop.company_name_in_foreign_language')" type="text" class="form-control" id="globalName"  v-bind:placeholder="$t('providers.cop.placeholder_company_name_foreign')">
                </div>

                <div class="form-group">
                  <label class="tilte-input" for="address">{{$t('providers.cop.head_address')}}</label>
                  <input :ref="$t('providers.fields.cop.address_of_head_office')" :data-vv-name="$t('providers.fields.cop.address_of_head_office')" key="address-of-head-office" v-validate="'required'" v-model="provider.headquarterAddress" :name="$t('providers.fields.cop.address_of_head_office')" type="text" class="form-control" id="address" v-bind:placeholder="$t('providers.cop.placeholder_head_address')">
                  <span v-if="errors.has($t('providers.fields.cop.address_of_head_office'))" class="text-danger error">{{errors.first($t('providers.fields.cop.address_of_head_office'))}}</span>
                </div>

                <div class="form-group">
                  <label class="tilte-input" for="Email">Email</label>
                  <!-- Code validate -->
                  <!-- <input ref="Email" data-vv-name="Email" v-validate="{required: true, email: true}" v-model="provider.email" name="Email" type="text" class="form-control" id="Email"  v-bind:placeholder="$t('providers.cop.placeholder_email')">
                  <span v-if="errors.has('Email')" class="text-danger error">{{errors.first('Email')}}</span> -->
                  <!-- No validate -->
                  <input data-vv-name="Email" v-model="provider.email" v-validate="{email: true}" name="Email" type="text" class="form-control" id="Email"  v-bind:placeholder="$t('providers.cop.placeholder_email')">
                  <span v-if="errors.has('Email')" class="text-danger error">{{errors.first('Email')}}</span>
                </div>

                <div class="form-group">
                  <label class="tilte-input" for="website">Website</label>
                  <input name="website" v-model="provider.website" type="text" class="form-control" id="website" aria-describedby="websiteHelp" v-bind:placeholder="$t('providers.cop.placeholder_website')">
                </div>

            </div>
          </div>

          <div class="row no-gutters mt-5">
            <div class="col-12 col-lg-6">
                <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.cop.step4')}}</h4>
                <div>
                  <p v-html="$t('providers.cop.des_step4')"></p>
                </div>
            </div>
          </div>
          <div class="row mt-3">
              <div class="col-12 col-lg-6" >
                  <UpLoadImage :id="$t('providers.fields.cop.registration_photos')" ref="uploadImage"  key="registration-photos" v-validate="'required'" :name="$t('providers.fields.cop.registration_photos')" v-model="provider.registrationPhotos" />
                  <span v-if="errors.has($t('providers.fields.cop.registration_photos'))" class="text-danger error">{{errors.first($t('providers.fields.cop.registration_photos'))}}</span>
              </div>
          </div>
        </div>
        <div v-if="provider.type === 'individual'">

            <div class="row no-gutters mt-5">
                <div class="col-12 col-lg-6">
                    <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.inv.step3')}}</h4>
                    <div>
                        <p v-html="$t('providers.inv.des_step3')"></p>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12 col-lg-6">
                    <div class="form-group">
                        <label class="tilte-input" for="idNo.">{{$t('providers.inv.id_no')}}</label>
                        <input :ref="$t('providers.fields.inv.id_no')" key="id-no" v-validate="{ required:true, numeric: true }" v-model="provider.idNumber" :name="$t('providers.fields.inv.id_no')" type="text" class="form-control"  v-bind:placeholder="$t('providers.inv.placeholder_id_no')">
                        <span v-if="errors.has($t('providers.fields.inv.id_no'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.id_no')) }}</span>
                    </div>

                    <div class="form-group">
                        <SelectDate :id="$t('providers.fields.inv.date_of_birth')" key="date-of-birth" v-validate="{required: true}" v-bind:title="$t('providers.inv.birthday')" :name="$t('providers.fields.inv.date_of_birth')" v-model="provider.birthDay"></SelectDate>
                        <span v-if="errors.has($t('providers.fields.inv.date_of_birth'))" class="text-danger error">{{errors.first($t('providers.fields.inv.date_of_birth'))}}</span>
                    </div>

                    <div class="form-group">
                        <label class="tilte-input" for="permanentAddress">{{$t('providers.inv.permanent_address')}}</label>
                        <input :ref="$t('providers.fields.inv.permanent_dddress')" key="permanent-dddress"  v-validate="'required'" v-model="provider.placeOfPermanent" :name="$t('providers.fields.inv.permanent_dddress')" type="text" class="form-control" v-bind:placeholder="$t('providers.inv.placeholder_permanent_address')">
                        <span v-if="errors.has($t('providers.fields.inv.permanent_dddress'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.permanent_dddress')) }}</span>
                    </div>

                    <div class="form-group">
                        <label class="tilte-input" for="region">{{$t('providers.inv.religion')}}</label>
                        <div class="d-flex justify-content-between">
                            <!-- Code validate -->
                            <select :id="$t('providers.fields.inv.religion')" key="religion" v-validate="'required'" v-model="provider.religion" :name="$t('providers.fields.inv.religion')" class="form-control">
                            <!-- Code No validate -->
                            <!-- <select  key="religion" v-model="provider.religion" :name="$t('providers.fields.inv.religion')" class="form-control"> -->
                                <option value="" disabled selected>
                                   {{$t('providers.inv.enter')}}
                                </option>
                                <option v-for="religion in religions"
                                        :key="religion"
                                        :value="religion"
                                        >
                                      {{ religion }}
                                </option>
                            </select>
                        </div>
                        <span v-if="errors.has($t('providers.fields.inv.religion'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.religion')) }}</span>
                    </div>

                  <div class="form-group">
                      <SelectDate :id="$t('providers.fields.inv.date_of_issue')" key="date-of-issue" v-validate="{required: true}" :name="$t('providers.fields.inv.date_of_issue')" v-bind:title="$t('providers.inv.issue_date')" v-model="provider.issueDate"></SelectDate>
                      <span v-if="errors.has($t('providers.fields.inv.date_of_issue'))" class="text-danger error">{{errors.first($t('providers.fields.inv.date_of_issue'))}}</span>
                  </div>
                </div>

                <div class="col-12 col-lg-6">

                    <div class="form-group">
                        <label class="tilte-input" for="fullName">{{$t('providers.inv.full_name')}}</label>
                        <input :ref="$t('providers.fields.inv.full_name')" key="full-name" v-validate="'required'" v-model="provider.fullName" :name="$t('providers.fields.inv.full_name')" type="text" class="form-control" v-bind:placeholder="$t('providers.inv.placeholder_full_name')">
                        <span v-if="errors.has($t('providers.fields.inv.full_name'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.full_name')) }}</span>
                    </div>

                    <div class="form-group">
                        <label class="tilte-input" for="nativePlace">{{$t('providers.inv.native_place')}}</label>
                        <div class="d-flex justify-content-between">
                            <select :id="$t('providers.fields.inv.birthplace_province')" key="birthplace-province"  v-validate="'required'" :name="$t('providers.fields.inv.birthplace_province')" v-model="provider.birthplaceProvince" @change="getDistricts(provider.birthplaceProvince)" class="form-control w-50 mr-3">
                                <option value="" disabled selected>
                                   {{$t('providers.inv.province')}}
                                </option>
                                <option
                                    v-for="(province, index) in provinces"
                                    :key="index"
                                    :value="province"
                                >
                                 {{ province.name }}
                                </option>
                            </select>
                            <select :id="$t('providers.fields.inv.birthplace_town')" key="birthplace-town" v-validate="'required'" :name="$t('providers.fields.inv.birthplace_town')" :disabled="!provider.birthplaceProvince" v-model="provider.birthplaceTown" class="form-control w-50">
                                <option value="" disabled selected>
                                   {{$t('providers.inv.town')}}
                                </option>
                                <option
                                   v-for="district in districts"
                                   :key="district"
                                   :value="district"
                                >
                                   <!-- {{$t('providers.inv.town')}} -->
                                   {{ district }}
                                </option>
                            </select>
                        </div>
                        <span v-if="errors.has($t('providers.fields.inv.birthplace_province'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.birthplace_province')) }}</span>
                        <span v-if="!errors.has($t('providers.fields.inv.birthplace_province')) && errors.has($t('providers.fields.inv.birthplace_town'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.birthplace_town')) }}</span>
                        <!-- <div class="d-flex justify-content-between">
                        </div> -->
                    </div>

                    <div class="form-group">
                        <label class="tilte-input" for="ethnicGroup">{{$t('providers.inv.ethnic')}}</label>
                        <div class="d-flex justify-content-between">
                            <!-- Code validate -->
                            <select :id="$t('providers.fields.inv.ethnicity_group')" key="ethnicity-group" v-validate="'required'" :name="$t('providers.fields.inv.ethnicity_group')" v-model="provider.ethnicity" class="form-control">
                            <!-- Code No validate -->
                            <!-- <select key="ethnicity-group" :name="$t('providers.fields.inv.ethnicity_group')" v-model="provider.ethnicity" class="form-control"> -->
                                <option value="" disabled selected>
                                   {{$t('providers.inv.enter_ethnic')}}
                                </option>
                                <option v-for="ethnic in ethnics"
                                        :key="ethnic"
                                        :value="ethnic"
                                        >
                                      {{ ethnic }}
                                </option>
                            </select>
                        </div>
                        <span v-if="errors.has($t('providers.fields.inv.ethnicity_group'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.ethnicity_group')) }}</span>
                    </div>

                    <div class="form-group">
                        <label class="tilte-input" for="tracesAndDeformities">{{$t('providers.inv.traces')}}</label>
                        <!-- Code validate -->
                        <!-- <input :ref="$t('providers.fields.inv.individual_traces_&_deformities')" key="individual-traces-deformities" v-validate="'required'" v-model="provider.deformity" :name="$t('providers.fields.inv.individual_traces_&_deformities')" type="text" class="form-control" id="tracesAndDeformities"  v-bind:placeholder="$t('providers.inv.placeholder_traces')">
                        <span v-if="errors.has($t('providers.fields.inv.individual_traces_&_deformities'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.individual_traces_&_deformities')) }}</span> -->
                        <!-- Code no validate -->
                        <input  key="individual-traces-deformities" v-model="provider.deformity" :name="$t('providers.fields.inv.individual_traces_&_deformities')" type="text" class="form-control" id="tracesAndDeformities"  v-bind:placeholder="$t('providers.inv.placeholder_traces')">
                    </div>

                    <div class="form-group">
                        <label class="tilte-input" for="placeOfIssue">{{$t('providers.inv.issue_place')}}</label>
                        <div class="d-flex justify-content-between">
                            <select :id="$t('providers.fields.inv.place_of_issue')" key="place-of-issue" v-validate="'required'" :name="$t('providers.fields.inv.place_of_issue')" v-model="provider.issuePlace" class="form-control">
                                <option value="" disabled selected>
                                      {{$t('providers.inv.enter_issue')}}
                                </option>
                                <option
                                    v-for="province in provinces"
                                    :key="province.name"
                                    :value="province.name"
                                >
                                   {{ province.name }}
                                </option>
                            </select>
                        </div>
                        <span v-if="errors.has($t('providers.fields.inv.place_of_issue'))" class="text-danger error">{{ errors.first($t('providers.fields.inv.place_of_issue')) }}</span>
                    </div>
                </div>
            </div>



            <div class="row no-gutters mt-5">
                <div class="col-12 col-lg-6">
                    <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.inv.step4')}}</h4>
                    <div>
                        <p v-html="$t('providers.inv.des_step4')"></p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 col-md-6 mb-5">
                    <UpLoadImage :id="$t('providers.fields.inv.front_side')" ref="uploadImage" key="front-side" v-validate="'required'" :label="$t('providers.inv.front_side')" :name="$t('providers.fields.inv.front_side')" :limit="1" v-model="provider.frontSide" />
                    <span v-if="errors.has($t('providers.fields.inv.front_side'))" class="text-danger error">{{errors.first($t('providers.fields.inv.front_side'))}}</span>
                </div>
                <div class="col-12 col-lg-6 col-md-6">
                    <UpLoadImage :id="$t('providers.fields.inv.back_side')" ref="uploadImage" key="back-side" v-validate="'required'" :name="$t('providers.fields.inv.back_side')" :label="$t('providers.inv.back_side')" :limit="1" v-model="provider.backSide" />
                    <span v-if="errors.has($t('providers.fields.inv.back_side'))" class="text-danger error">{{errors.first($t('providers.fields.inv.back_side'))}}</span>
                </div>
            </div>

        </div>


        <div class="row no-gutters mt-5">
          <div class="col-12 col-lg-6">
              <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.step5')}}</h4>
              <div>
                <p v-html="$t('providers.des_step5')"></p>
              </div>
          </div>
        </div>
        <!-- v-bind:categories="categories" -->
        <!-- CHOOSE CATEGORIES FOR PROVIDER -->
        <ChooseCategories :id="$t('providers.fields.categories')" v-model="categoryIds" :name="$t('providers.fields.categories')" v-validate="'required'" v-bind:categoryIds="categoryIds" @categoryIds="categoryIds = $event"  />
        <span v-if="errors.has($t('providers.fields.categories'))" class="text-danger error">{{errors.first($t('providers.fields.categories'))}}</span>


        <div class="row no-gutters mt-5">
          <div class="col-12 col-lg-6">
              <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.step6')}}</h4>
              <div>
                <p v-html="$t('providers.des_step6')"></p>
              </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12 col-lg-6">
             <AddressInput :data-vv-name="$t('providers.fields.locations')" :id="$t('providers.fields.locations')" :name="$t('providers.fields.locations')" v-validate="'required|inArray'" v-bind:label="$t('providers.step6_label_add')" :mapIcon="true"  :max="maxLocation" v-model="provider.locations" />
             <span v-if="errors.has($t('providers.fields.locations'))" class="text-danger error">{{errors.first($t('providers.fields.locations'))}}</span>
          </div>
        </div>

        <div v-if="provider.type === 'company'" class="row no-gutters mt-5">
          <div class="col-12 col-lg-6">
              <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.co_step7.step7')}}</h4>
              <div class="mt-2">
                <p v-html="$t('providers.co_step7.des_step7_1')"></p>
                <p v-html="$t('providers.co_step7.des_step7_2')"></p>
                <p v-html="$t('providers.co_step7.des_step7_3')"></p>
              </div>
              <div class="mt-4">
                <p v-html="$t('providers.co_step7.des_step7_4', {'msg': noticePeriod })"></p>
                <p v-html="$t('providers.co_step7.des_step7_6')"></p>
              </div>
              <div class="mt-4">
                <p v-html="$t('providers.co_step7.des_step7_7')"></p>
              </div>
              <div class="mt-4">
                <p v-html="$t('providers.co_step7.des_step7_8', {'hotline': hotline})"></p>
              </div>
          </div>
        </div>

        <div v-if="provider.type === 'individual'" class="row no-gutters mt-5">
          <div class="col-12 col-lg-6">
              <h4 class="step-title font-weight-bold text-secondary">{{$t('providers.inv_step7.step7')}}</h4>
              <div class="mt-2">
               <p v-html="$t('providers.inv_step7.des_step7_1')"></p>
                <p v-html="$t('providers.inv_step7.des_step7_2')"></p>
                <p v-html="$t('providers.inv_step7.des_step7_3')"></p>
              </div>
              <div class="mt-4">
                <p v-html="$t('providers.inv_step7.des_step7_4', {'msg': noticePeriod })"></p>
                <p v-html="$t('providers.inv_step7.des_step7_6')"></p>  
              </div>
              <div class="mt-4">
                <p v-html="$t('providers.inv_step7.des_step7_7', {'hotline': hotline})"></p>
              </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12 col-lg-6">
            <div class="form-check" @click="checkPolicyAndTerms = !checkPolicyAndTerms">
              <input ref="checkPolicyAndTerms" :checked="checkPolicyAndTerms"  class="form-check-input" type="checkbox" value="" id="checkPolicyAndTerms">
              <label class="form-check-label text-size">
                 {{$t('providers.note1')}}
                 <p v-html="$t('providers.note2')"></p>
              </label>
            </div>
          </div>
        </div>

        <div class="row mt-2">
            <div class="col-12 col-lg-6">
              <!-- :disabled="isFormValid" -->
              <div class="d-flex justify-content-between align-items-center">
                <button :disabled="disabledBtnSubmit"  @click="save()" class="btn p-3 btn-submit btn-block text-white text-uppercase font-weight-bold">
                  {{$t('providers.btn_ok')}}
                </button>
                <span class="loading p-2" v-if="loading"></span>
               </div>
            </div>
        </div>

      </div>
    </WhiteRow>
  </div>
</template>
<style lang="scss">
.text-black{
  color: black;
}
</style>

<style lang="scss" scoped>
$radius: 50px;

#NewProvider{
  font-size: 1.1rem;
  color: #000000;

  .btn-submit{
    background-color:#0075FF;
    border-radius: 14px;
  }
  .btn-submit:hover{
    opacity: 0.8;
  }

  .form-padding-common{
    padding: 0.6rem 0.2rem; 
  }

  .download-app-title{
    font-weight: 600;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
.cursor-pointer{
  cursor: pointer;
}
.provider-type{
  font-size: 50px;
}
.w-30{
  width: 30%;
}
.w-70{
  width: 70%;
}
.activeType{
  background:var(--primary);
  border: none !important;
  i{
    color: white;
  }
}
.border-setp-two-right{
  border-bottom: 5px  solid #EBEBEB;
  border-top: 5px  solid #EBEBEB;
  border-right: 5px  solid #EBEBEB;
}
.error{
  font-size: 14px;
}
.image-type{
  width: 150px;
  height: 130px;
  //   width: 180px;
  // height: 200px;
}
.border-setp-two-left{
    border: 5px  solid #EBEBEB;
}

.text-size{
  font-size: 1rem;
}

.text-black{
  color: black;
}

.text-gray{
  color: #E6E6E6;
}

.tilte-input{
  font-size: 0.9rem;
  color: black;
}

.bg-blue{
  background-color: var(--blue);
}

.banner-image {
  background: url("~@/assets/workers.png") no-repeat left center;
  background-size: contain;
  min-height: 300px;
  border-radius: 0 $radius $radius 0;
}
.primary-heading{
  font-size: 1.32rem;
  font-weight: bold;
  line-height: 1.3; 
}

.countdown{
  font-size: 15px;
}

.step-title{
  font-size: 1.32rem;
}

.loading {
  margin: 20px;
  display: inline-block;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #ffbe17;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 0.9s linear infinite;
  animation: spin 0.8s linear infinite;
}

.verified{
  color: var(--success);
}

.remove-phone-number{
  top: 13px;
  right: 10px;
  font-size: 18px;
  color: red;
  cursor: pointer;
}

.show-interface-verify-code{
  width: 100%;
  .box-verify-code{
    // margin-left: 20px;
    .code{
      width: 60%;
    }

    .btn-confirm{
      width: 39%;
    }
  }
}


@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}


@media screen and (min-width: 500px){
  #NewProvider{
    .form-padding-common{
      padding: 0.6rem 1rem; 
    }
  }

  .show-interface-verify-code{
    width: 100%;
    .box-verify-code{
      margin-left: 27.5%;
      .code{
        width: 61%;
      }

      .btn-confirm{
        width: 39%;
      }
    }
  }
}

@media screen and (min-width: 576px){

  .show-interface-verify-code{
    .box-verify-code{
      margin-left: 27%;
    }
  }

  .loading {
    width: 30px;
    height: 30px;
  }
}

@media screen and (min-width: 768px){
    #NewProvider{
      .download-app-title{
        margin-bottom: 12px;
        font-size: 1.32rem;
        line-height: 1.3;
      }
      .download-app{
        display: flex;
        .google-play{
          img{ 
              width: 150px;
          }
      }
      .app-store{
        img{ 
            width: 150px;
        }
      }
    }
  }
}

@media screen and (min-width: 992px){
  #NewProvider{
    .download-app-title{
      font-size: 1.32rem;
      margin-top: 5px;
      margin-bottom: 20px;
    }
    .download-app{
      display: flex;
      .google-play{
        img{ 
            width: 165px;
        }
      }
      .app-store{
        img{ 
            width: 165px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px){
  #NewProvider{
    font-size: 1.55rem;

    .download-app-title{
      font-size: 1.55rem;
      margin-top: 5px;
      margin-bottom: 20px;
    }
    .download-app{
      display: flex;
      .google-play{
        img{ 
            width: 165px;
        }
      }
      .app-store{
        img{ 
            width: 165px;
        }
      }
    }
  }

  .primary-heading{
    font-size: 1.8rem;
  }

  .step-title{
    font-size: 1.8rem;
  }

  .banner-image {
    min-height: 450px;
  }
}


</style>

<script>

import Vue from 'vue';
import firebase from 'firebase';
import VeeValidate, { Validator } from 'vee-validate';
// import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
Validator.extend('inArray',{
  getMessage(field){
    if(localStorage && localStorage.language == 'vi'){
        return `${field} là bắt buộc`;
    }
    return `The ${field} field is required`;
  },
  validate: (args) => {
      console.log(`locations: ${JSON.stringify(args)}`);
      for (var i = 0; i < args.length; i++) {
        if (args[i].address == "") {
          return false;
        }
      }
    return true;
  }
});

// @ is an alias to /src
import BannerRow from "@/components/BannerRow.vue";
import WhiteRow from "@/components/WhiteRow.vue";
import UpLoadImage from "@/components/UpLoadImage.vue";
import AddressInput from "@/components/AddressInput.vue";
import SelectDate from "@/components/SelectDate.vue";

import ChooseCategories from "@/components/ChooseCategories.vue";


import Religions from '../constants/religions-vi.json';
import Ethnics from "../constants/ethnics-vi.json";
let Provinces = {};

import(`../constants/provinces-${(localStorage && localStorage.language) || 'vi'}.json`).then(results => {
  let temporaryProvinces = {};
    for(let province in results){
      if(results[province].name){
        temporaryProvinces[province] = results[province];
      }
    }
  Provinces = temporaryProvinces;
});


export default {
  name: "Home",
  components: {
    BannerRow,
    WhiteRow,
    UpLoadImage,
    AddressInput,
    SelectDate,
    ChooseCategories
  },
  data() {
    return {
       provider: {
         type: "company",
         businessCode: "",
         idNumber: "",
         localName: "",
         phones: [],
         phone: "",
         fax: "",
         deformity: "",
         placeOfPermanent:"",
         globalName:"",
         registrationDate: "",
         issueDate:"",
         idCardPhotos: [],
         religion:"",
         locations: [],
         ethnicity:"",
         issuePlace: "",
         birthplaceProvince: "",
         birthplaceTown: "",
         phoneRegionNumber: "",
         phoneRegionFax: "",
         email:"",
         birthDay:"",
         registrationPhotos: [],
         frontSide: [],
         backSide: []
       },
       code:"",
       user:{
         phoneRegion: '',
            phone: '',
            error: '',
            loading: false,
            verified: false,
       },
       disabledPhoneNumber: false,
       displayGetACode: true,
       loading: false,
       currentUser:{},
       phoneRegions: {},
       religions: [],
       ethnics: [],
       provinces: [],
       services: [],
       categories:[],
       categoryIds: [],
       districts:{},
       validateUser:{},
       checkPolicyAndTerms: false,
       resetDateTime: false,
       maxLocation: 3,
       hotline: "",
       noticePeriod: "",
       isPhoneNumber: true,
       disabledBtnSubmit: false,
       isShowInterfaceVerifyCode: false,
       isShowCountDown: false,
       countDown: 60
    }
  },
  filters:{
    // formatDate(value){
    //   return moment(value).format('YYYY-MM-DD');
    // }
  },
  watch:{
     'user.phone':function(value) {
        this.user.error = "";
        this.isPhoneNumber = this.checkPhoneNumber(value);
        if(value.length > 9){
          if(value[0] != 0){
            this.user.error = this.$t('providers.phone_number_invalid');
            this.isPhoneNumber = true;
          }
        }
     }
  },
  computed: {
    years(){
      var year = new Date().getFullYear() + 1;
      return Array.from({ length: year - 1990}, (value, index) => 1990 + index );
    }

    //  isFormValid(){
    //       const invalid = function(item) {
    //         return item === true;
    //       }
    //       return (this.$validator.fields).map(field => field.flags.invalid).some(invalid);
    //   }
  },
  methods: {
      checkPhoneNumber(value){
        if(Number(value)){
          let regexPhone = /(?:\s+|)((0|(?:(\+|)91))(?:\s|-)*(?:(?:\d(?:\s|-)*\d{9})|(?:\d{2}(?:\s|-)*\d{8})|(?:\d{3}(?:\s|-)*\d{7}))|\d{9})(?:\s+|)/;
          if(regexPhone.test(value)){
            return false;
          }
          return true;
        }
        return true;
      },
      changeProviderType(value) {
        this.$validator.pause();
        this.resetFieldsProvider();
        this.provider.type = value;
        // this.$nextTick(() => {
        //   this.$validator.reset();
        // });
        this.$nextTick(() => {
          this.defaultPhoneRegion();
          this.$validator.errors.clear();
          this.$validator.fields.items.forEach(field => field.reset());
          this.$validator.fields.items.forEach(field => this.errors.remove(field));
          this.$validator.resume();
        })      
        this.$forceUpdate();
      },
      // chooseCategoriesForProvider(categoryId, categoryName){
      //   // let el = event.target.tagName;
      //   // console.log("ell", el);
      //   if(!this.categoryIds.includes(categoryId)){
      //     this.categoryIds.push(categoryId);
      //     event.target.innerHTML = categoryName;
      //   }else{
      //     var index = this.categoryIds.indexOf(categoryId);
      //     this.categoryIds.splice(index, 1);
      //     event.target.innerHTML = this.$t('providers.step5_add')+" "+categoryName;
      //   }
      //   // console.log("categoryId", categoryId);
      //   // console.log("categoryIds", this.categoryIds);
      // },
      getDistricts(province) {
          this.districts = {},
          Object.assign(this.districts, province.districts);
          this.provider.birthplaceTown = "";
      },
      resetFieldsProvider(){
         this.provider = {
            type: "company",
            businessCode: "",
            idNumber: "",
            localName: "",
            phones: [],
            phone: "",
            fax: "",
            deformity: "",
            placeOfPermanent:"",
            globalName:"",
            registrationDate: '',
            issueDate:'',
            idCardPhotos: [],
            religion:"",
            locations: [],
            ethnicity:"",
            email:"",
            issuePlace: "",
            birthplaceProvince: "",
            birthplaceTown: "",
            phoneRegionNumber: "",
            phoneRegionFax: "",
            birthDay:"",
            registrationPhotos: [],
            frontSide: [],
            backSide: []
          },
          this.categoryIds = []
      },
      resetFields(){
         this.provider = {
            type: "company",
            businessCode: "",
            idNumber: "",
            localName: "",
            phones: [],
            phone: "",
            fax: "",
            deformity: "",
            placeOfPermanent:"",
            globalName:"",
            registrationDate: '',
            issueDate:'',
            idCardPhotos: [],
            religion:"",
            locations: [],
            email: "",
            ethnicity:"",
            issuePlace: "",
            birthplaceProvince: "",
            birthplaceTown: "",
            phoneRegionNumber: "",
            phoneRegionFax: "",
            birthDay:"",
            registrationPhotos: [],
            frontSide: [],
            backSide: []
          },
          this.categoryIds = [],
          this.checkPolicyAndTerms = false
          this.user.phone = '',
          this.user.error = ''
      },
      handleValidationError(){
        const firstField = Object.keys(this.errors.collect())[0];
        try{
          this.$refs[`${firstField}`].scrollIntoView();
          this.$refs[`${firstField}`].focus();
        }catch(e) {
          let divFocus = '#'+firstField+'';
          window.location.href = divFocus;
        }
      },
      async save(){
          try{
            // for(let item of this.$validator.fields.items){
            //   console.log("okkk",item.name);
            //   if(item.flags.invalid){
            //       // var el = document.querySelector('[data-vv-name="' + item.name + '"]');
            //       // if(el.focus() == null){
            //       //   continue;
            //       // }
            //       // el.focus()
            //       break;
            //   }
            // }

            this.$validator.validateAll().then(async res => {
              if(!res){
                  this.handleValidationError();
              }
              if(res){
                if(this.$refs.checkPolicyAndTerms.checked == false){
                    this.$refs.checkPolicyAndTerms.focus();
                    return;
                }
                if(this.provider.type === 'company'){
                  this.provider.displayName = this.provider.localName;
                  if(this.provider.phone && this.provider.phone != ""){
                    this.provider.phones.push(this.provider.phoneRegionNumber +""+ this.provider.phone);
                  }
                }
                if(this.provider.type === 'individual'){
                    this.provider.idCardPhotos = [];
                    if(this.provider.frontSide[0]){
                      this.provider.idCardPhotos.push(this.provider.frontSide[0]);
                    }
                    if(this.provider.backSide[0]){
                      this.provider.idCardPhotos.push(this.provider.backSide[0]);
                    }
                    this.provider.birthplaceProvince = this.provider.birthplaceProvince.name;
                    this.provider.displayName = this.provider.fullName;
                }

                const { data: { results} } = await this.$store.$oddjob.users.currentUser();
                if(results && results.length > 0){
                    this.loading = true;
                    this.currentUser = results[0];
                    const {data: { results: newProvider}} = await this.$store.$oddjob.serviceProviders.updateProvider("_me", this.provider);
                    if(newProvider && newProvider.length > 0){
                      console.log("currentUser",  this.currentUser);
                      console.log("categoryIds", this.categoryIds);
                      console.log("locations", this.provider.locations);

                      await this.createServicesForProvider(newProvider[0]._id, this.categoryIds);
                        this.provider.locations.forEach(location =>{
                          location.provider = newProvider[0]._id;
                          location.user = newProvider[0]._id;
                      });
                    
                      await this.createLocationsForProvider(newProvider[0]._id, this.provider.locations);
                      await this.setVerificationStatus(newProvider[0]._id);
                      console.log("new provider", newProvider);
                      this.loading = false;
                      alert(this.$t("providers.new_provider_successfully"));
                      this.resetDateTime = true;
                      this.$refs.uploadImage.reset();
                      this.user.verified = false;
                      this.displayGetACode = true;
                      this.disabledPhoneNumber = false;
                      this.$validator.pause();
                      this.resetFields();
                      this.$nextTick(function () {
                          this.defaultPhoneRegion();
                          this.$validator.errors.clear();
                          this.$validator.fields.items.forEach(field => field.reset());
                          this.$validator.fields.items.forEach(field => this.errors.remove(field));
                          this.$validator.resume();
                      })

                  }
                }
              }
            })
            this.$forceUpdate();
          }catch(e){
            console.log("API new provider failed",e);
          }
      },
      async setVerificationStatus(providerId){
          const { data: {message, results, code} } = await this.$store.$oddjob.serviceProviders.setVerifiedStatus(providerId);
          if(results && results.length > 0 && code != "param_invalid"){
            console.log("setVerificationStatus", results[0]);
            return results[0];
          }
          if(code == "param_invalid" && message == "The field is required"){
            console.log(`data`, JSON.stringify(results));
          }
      },
      async createServicesForProvider(providerId, categoryIds){
          const { data: { results}} = await this.$store.$oddjob.serviceProviders.createServices(providerId, { categoryIds });
          if(results && results.length > 0){
            console.log("createdServicesForProvider", results[0]);
            return results[0];
          }
      },
      async createLocationsForProvider(providerId, locations){
          try{
               const { data: { results }} = await this.$store.$oddjob.serviceProviders.setLocationsProvider(providerId, { locations })
               if(results && results.length > 0){
                  console.log("createLocationsForProvider", results[0]);
                  return results[0];
               }
          }catch(e){
            console.log("API create locations failed", e);
          }
      },
      removePhoneNumber(){
          this.user.verified = false;
          this.user.phone = "";
          this.disabledPhoneNumber = false;
          this.displayGetACode = true;
      },
      async isProviderExists(){
         try{
            const { data: { results }} = await this.$store.$oddjob.serviceProviders.getProviderById("_me");
            if(results && results.length > 0){
              return true;
            }
            return false;
         }catch(e) {
            console.log("API get provider error", e);
         }
      },
      async setUserRoleIsProvider(){
          const { data: {results } } = await this.$store.$oddjob.users.updateUser("_me", { role: 'provider'});
          if(results && results.length > 0){
             console.log("Set user role is provider success", results[0]);
          }
      },
       resetInterfaceVerifyCode(){
          this.isShowInterfaceVerifyCode = false;
          this.code = "";
      },

      async createUserOnFireBase(otp){
          var phoneNumber = this.user.phoneRegion + parseInt(this.user.phone);
          this.user.loading = true;
          console.log(otp);
          console.log(phoneNumber);
          const { data: { message, results, code } } = await this.$store.$oddjob.auth.verifyAuthOtp(phoneNumber, otp);
          if(results && results.length > 0 ){
            console.log(`results ${results[0].token}`);
            var token = results[0].token;
            firebase.auth().signInWithCustomToken(token).then(async(result)=>{
                console.log('currentUser',result);
                var providered = await this.isProviderExists();
                if(providered){
                  this.resetCountDown();
                  this.resetInterfaceVerifyCode();
                  this.user.error = this.$t('providers.phone_number_exists');
                  this.displayGetACode = true;
                
                  this.disabledBtnSubmit = true;
                }else{

                  await this.setUserRoleIsProvider();

                  this.resetCountDown();
                  this.resetInterfaceVerifyCode();
                  this.disabledPhoneNumber = true;
                  this.displayGetACode = false;
                  this.user.error = '';
                  this.user.verified = true;
                    
                  this.disabledBtnSubmit = false;
                }
                this.user.loading = false;
            })
            .catch((errors) => {
              console.log(errors);
              let { message }  = errors
              this.displayGetACode = true;
              this.user.error = message;
              this.resetCountDown();
              this.resetInterfaceVerifyCode();
              this.user.loading = false;
            });
         }else{
            if(message == 'Invalid code' && code == 'param_invalid_value'){
               this.user.error = this.$t('providers.sms_invalid');
            }
            this.user.loading = false;
         }
      },
      resetCountDown(){
        this.countDown = 60;
        this.isShowCountDown = false;
      },
      countDownTimer() {
          this.isShowCountDown = true;
          this.countDown = 60;
          if(this.countDown > 0) {
             setInterval(() => {  
                this.countDown -= 1
                 if(this.countDown == 0){
                  this.resetCountDown();
                  this.isShowInterfaceVerifyCode = false;
                  this.displayGetACode = true;
                  this.user.error = '';
                }
             }, 1500)
          }
      },
      async sendCode(){
        this.disabledBtnSubmit = false;

        this.user.phone = parseInt(this.user.phone);
        var phoneNumber = this.user.phoneRegion + this.user.phone;
        const { data: { message, results, code } } = await this.$store.$oddjob.auth.sendAuthOtpByPhone(phoneNumber);
          if(results && results.length > 0){
            this.isShowInterfaceVerifyCode = true;
            this.isShowCountDown = true;
            this.displayGetACode = false;
            this.countDownTimer();
          }else{
            if(message == 'Phone number invalid!' && code == 'invalid_phone_format'){
               this.user.error = this.$t('providers.phone_number_invalid');
            }
            this.displayGetACode = true;
            this.isShowInterfaceVerifyCode = false;
          }
      },
      async getSupportedPhoneRegions(){
          const {
              data: { results }
          } = await this.$store.$oddjob.settings.getSupportedPhoneRegions();
          let phoneRegions = results && results.length > 0 ? results : [];
          return phoneRegions;
      },
     async defaultPhoneRegion(){
          if(this.phoneRegions && this.phoneRegions.length > 0){
              this.user.phoneRegion = this.phoneRegions[0];
              this.provider.phoneRegionNumber =  this.phoneRegions[0];
              this.provider.phoneRegionFax = this.phoneRegions[0];
          }
     },
     async getConfigMaxLocation(){
        try{
          const {
              data: { results }
          } = await this.$store.$oddjob.settings.getConfigMaxLocation("max_location");
          return results && results.length > 0 ? results[0].value : 1
        }catch(e) {
          console.log("API get config max location failed", e);
        }
     },
     async getConfigHotline(){
        try{
            const {
                data: { results }
            } = await this.$oddjob.settings.getConfigHotline("hotline");
            return results && results.length > 0 ? results[0].value : '';
        }catch(e) {
          console.log("API get config hotline failed", e);
        }
     },
     async getConfigNoticesPeriod(){
        try{
            const {
                data: { results }
            } = await this.$oddjob.settings.getConfigNoticesPeriod("notice_period");
            return results && results.length > 0 ? results[0].value : 1;
        }catch(e) {
          console.log("API get config notices period failed", e);
        }
     }
  },
  async mounted() {
    try{
       // window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
      //   size: 'invisible'
      // });
      this.phoneRegions = await this.getSupportedPhoneRegions();
      await this.defaultPhoneRegion();
      this.maxLocation = await this.getConfigMaxLocation();
      this.hotline = await this.getConfigHotline();
      this.noticePeriod  = await this.getConfigNoticesPeriod();
      this.religions = Religions;
      this.ethnics = Ethnics;
      this.provinces = Provinces;
    }catch(e){
      console.log(e);
    }
  },
    // beforeDestroy(){
    //     this.$validator.pause();
    // }
};
</script>
